import React from "react";
import InformationPage from "components/shared/InformationPage";
import ApiInformationPage from "models/data/api/ApiInformationPage";
import withApollo from "components/higher-order/withApollo";
import PageContainer from "components/containers/PageContainer";
import { useRecordPageView } from "hooks/analytics/useRecordPageView";
import { NextSeo } from "next-seo";

function AboutUs() {
  useRecordPageView();

  return (
    <PageContainer>
      <NextSeo
        title="About Us | The Juggernaut"
        twitter={{ cardType: "summary_large_image" }}
        openGraph={{
          title: "About Us",
          type: "website",
          site_name: "The Juggernaut",
        }}
      />
      <InformationPage page={ApiInformationPage.pages.ABOUT_US} />
    </PageContainer>
  );
}

export default withApollo(AboutUs);
